import ReactLoadingSkeleton from 'react-loading-skeleton';

export const KPIBreakdownSkeleton = ({ breakdownItemsCount = 3 }) => {
  return (
    <div className="mt-2 flex flex-col gap-1">
      {Array.from({ length: breakdownItemsCount }, () => (
        <div className="flex gap-2" key={crypto.randomUUID()}>
          <ReactLoadingSkeleton borderRadius={1} height={16} width={115} />
          <ReactLoadingSkeleton borderRadius={1} height={16} width={60} />
        </div>
      ))}
    </div>
  );
};
